import { generateTypes } from '../../utils/HttpReducerHelper';

export const casesSummary = generateTypes('DASHBOARD', 'CASES_SUMMARY');
